import { render, staticRenderFns } from "./CampaignInfo.vue?vue&type=template&id=66672dd8"
import script from "./CampaignInfo.vue?vue&type=script&lang=ts"
export * from "./CampaignInfo.vue?vue&type=script&lang=ts"
import style0 from "./CampaignInfo.vue?vue&type=style&index=0&id=66672dd8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports